module.exports = __webpack_public_path__ + "static/img/apk.f5c5a5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apk.png
// module id = ft+i
// module chunks = 1